/* eslint-disable promise/catch-or-return, promise/always-return */
import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import Animasjonsscroll from './components/animasjonsscroll'
import ProsentvisVideo from './components/media/prosentvis-video'
import ProsentvisBilde from './components/media/prosentvis-bilde'
import ProsentvisOvergang from './components/media/prosentvis-overgang'

import './components/animasjonsscroll.module.css'
import './client.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends BaseElement {
  name = tag

  connectedCallback() {
    super.connectedCallback()

    if (this.features.sanityPreview) {
      import(
        './components/preview/preview-iframe-api' /* webpackChunkName: "dh-preview-iframe" */
      ).then((module) => module.initPreview(tag))
    }
  }

  async render() {
    safeDefine('dh-animasjonsscroll', Animasjonsscroll)
    safeDefine('dh-prosentvis-video', ProsentvisVideo)
    safeDefine('dh-prosentvis-bilde', ProsentvisBilde)
    safeDefine('dh-prosentvis-overgang', ProsentvisOvergang)

    if (this.features.lottie && typeof customElements.get('dh-prosentvis-lottie') === 'undefined') {
      const prosentvisLottie = (
        await import(
          './components/media/prosentvis-lottie' /* webpackChunkName: "dh-prosentvis-lottie" */
        )
      ).default
      safeDefine('dh-prosentvis-lottie', prosentvisLottie)
    }

    if (this.features.gltf && typeof customElements.get('dh-prosentvis-gltf') === 'undefined') {
      const prosentvisGLTF = (
        await import(
          './components/media/prosentvis-gltf' /* webpackChunkName: "dh-prosentvis-gltf" */
        )
      ).default
      safeDefine('dh-prosentvis-gltf', prosentvisGLTF)
    }
  }

  get features() {
    return JSON.parse(this.getAttribute('features') || '{}')
  }
}

safeDefine(tag, AppElement)
